import React, { useEffect, useRef, useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { connect } from "react-redux";
import { adminDashboardData } from "../../actions/defaultDataAction";
import DropDown from "../../components/DropDown";

const shipmentModeOption = [
  { label: "Import", value: "Import" },
  { label: "Export", value: "Export" },
  { label: "Logistic Partner", value: "Logistic Partner" },
  { label: "Trader", value: "Trader" },
  { label: "Manufacturer", value: "Manufacturer" },
];

const AmChartComponent = (props) => {
  const chartRef = useRef(null);
  const [chartdata, setChartData] = useState([]);
  const [shipment_mode, setShipmentMode] = useState(shipmentModeOption[0]); // Default to "Import"
  const [dashboardData, setDashboardData] = useState([]);

  const [formData, setFormData] = useState({
    action: ["barChartData"],
    shipment_mode: "Import",
  });

  // Fetch data when formData changes (which includes shipment_mode)
  useEffect(() => {
    if (formData.shipment_mode) {
      fetchBarChartData();
    }
  }, [formData]);

  const fetchBarChartData = async () => {
    try {
      const response = await props.getAdminDashboardData(formData);
      setDashboardData(response);
    } catch (err) {
      console.error("Error fetching bar chart data:", err);
    }
  };
  

  // Set chart data from dashboard API
  useEffect(() => {
    if (dashboardData?.barChart) {
      setChartData(dashboardData.barChart);
    }
  }, [dashboardData]);

  // AMCharts rendering effect
  useEffect(() => {
    if (!chartdata || chartdata.length === 0 || !chartRef.current) return;

    am5.array.each(am5.registry.rootElements, (root) => {
      if (root.dom === chartRef.current) root.dispose();
    });

    const root = am5.Root.new(chartRef.current);
    root.setThemes([am5themes_Animated.new(root)]);
    root._logo.dispose(); //remove logo

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        pinchZoomX: false,
        paddingLeft: 0,
        paddingTop: 20,
        layout: root.verticalLayout,
      })
    );

    const data = chartdata.map((item) => ({
      year: item.industy_name || "Unknown",
      data1: Number(item.web_count) || 0,
      data2: Number(item.scripted_count) || 0,
    }));

    const maxStackedValue = Math.max(0, ...data.map((item) => item.data1 + item.data2));
    const yAxisMax = Math.max(Math.ceil(maxStackedValue * 1.4), 20);

    const xRenderer = am5xy.AxisRendererX.new(root, { minorGridEnabled: true });
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "year",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    xRenderer.labels.template.setAll({
      rotation: -45,
      centerY: am5.p50,
      centerX: am5.p50,
      paddingRight: 10,
      textAlign: "center",
      oversizedBehavior: "wrap",
      maxWidth: 100,
    });

    xAxis.data.setAll(data);
    xAxis.set("interactive", false);

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        max: yAxisMax,
        strictMinMax: true,
        renderer: am5xy.AxisRendererY.new(root, {
          strokeOpacity: 0.1,
        }),
      })
    );
    yAxis.set("interactive", false);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50,
      })
    );

    const makeSeries = (name, fieldName, color) => {
      const series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name,
          stacked: true,
          xAxis,
          yAxis,
          valueYField: fieldName,
          categoryXField: "year",
        })
      );

      series.columns.template.setAll({
        tooltipText: "{name}, {categoryX}: {valueY}",
        tooltipY: am5.percent(10),
        fill: am5.color(color),
        stroke: am5.color(color),
      });

      // series.bullets.push(() =>
      //   am5.Bullet.new(root, {
      //     locationY: 0.5,
      //     sprite: am5.Label.new(root, {
      //       text: "{valueY}",
      //       fill: root.interfaceColors.get("alternativeText"),
      //       centerY: am5.p50,
      //       centerX: am5.p50,
      //       populateText: true,
      //       oversizedBehavior: "wrap",
      //       maxWidth: 50,
      //       fontSize: 12,
      //     }),
      //   })
      // );

      series.data.setAll(data);
      series.appear();
      legend.data.push(series);
    };

    makeSeries("Web", "data1", "#0b4471");
    makeSeries("Scripted", "data2", "#1464a3");

    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [chartdata]);

  const handleShipmenMode = (val) => {
    setShipmentMode(val);
    setFormData((prev) => ({
      ...prev,
      shipment_mode: val.value,
    }));
  };

  return (
    <>
      <div className="head underline">
        <h3 className="m-0">Top Industries</h3>
        <DropDown
          placeholder={"Select trade mode"}
          options={shipmentModeOption}
          onChange={handleShipmenMode}
          value={shipment_mode}
          name="shipment_mode"
          id="shipment_mode"
          noOptionsMessage={() => "No Trade Mode Found"}
        />
      </div>
      <div ref={chartRef} style={{ width: "100%", height: "500px" }}></div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminDashboardData: (formData) => dispatch(adminDashboardData(formData)),
  };
};
export default connect(null, mapDispatchToProps)(AmChartComponent);
